// frontend/src/components/leveling/TierUpModal.js
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Dialog, DialogContent } from "../ui/dialog";
import { Button } from "../ui/button";
import { tierDisplay } from "../../lib/leveling";

export default function TierUpModal() {
  const [params, setParams] = useSearchParams();
  const tier = params.get("tierup");
  const open = !!tier;
  const td = tier ? tierDisplay(tier) : null;

  const close = () => {
    const next = new URLSearchParams(params);
    next.delete("tierup");
    setParams(next, { replace: true });
  };

  useEffect(() => {
    if (open) {
      // small confetti via dynamic import to avoid bundle bloat
      import("canvas-confetti").then((m) => {
        m.default({ particleCount: 80, spread: 70, origin: { y: 0.6 } });
      }).catch(() => {});
    }
  }, [open]);

  if (!open || !td) return null;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="bg-gradient-to-br from-black via-zinc-950 to-black border-white/10 max-w-sm">
        <div className="flex flex-col items-center text-center py-4 space-y-4">
          <div
            className="h-24 w-24 rounded-full flex items-center justify-center text-3xl font-black"
            style={{
              background: `radial-gradient(circle, ${td.color}, transparent 70%)`,
              color: td.color,
              boxShadow: `0 0 32px ${td.color}`,
            }}
          >
            ✦
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest text-white/60">New tier</p>
            <h2 className="text-3xl font-black mt-1" style={{ color: td.color }}>{td.label}</h2>
          </div>
          <p className="text-sm text-white/70">Keep showing up.</p>
          <div className="flex gap-2 w-full pt-2">
            <Button variant="outline" className="flex-1" onClick={close}>Continue</Button>
            <Button
              className="flex-1"
              style={{ background: td.color, color: "#000" }}
              onClick={async () => {
                try {
                  const { default: client } = await import("../../api/client");
                  await client.post("/social/posts", {
                    type: "tier_up",
                    metadata: { tier, label: td.label },
                  });
                } catch {}
                close();
              }}
            >
              Share to feed
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
